import request from '@/utils/request'


// 查询订单付款列表
export function listOrderPayment(query) {
  return request({
    url: '/user/order-payment/list',
    method: 'get',
    params: query
  })
}

// 查询订单付款分页
export function pageOrderPayment(query) {
  return request({
    url: '/user/order-payment/page',
    method: 'get',
    params: query
  })
}

// 查询订单付款详细
export function getOrderPayment(data) {
  return request({
    url: '/user/order-payment/detail',
    method: 'get',
    params: data
  })
}

// 新增订单付款
export function addOrderPayment(data) {
  return request({
    url: '/user/order-payment/add',
    method: 'post',
    data: data
  })
}

// 修改订单付款
export function updateOrderPayment(data) {
  return request({
    url: '/user/order-payment/edit',
    method: 'post',
    data: data
  })
}

// 删除订单付款
export function delOrderPayment(data) {
  return request({
    url: '/user/order-payment/delete',
    method: 'post',
    data: data
  })
}
